







































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import TwoFactorBox from './TwoFactorBox.vue';
import { CopyToClipboard } from '~/mixins';
import { Mutation, State } from 'vuex-class';
import twoFaRegister from '@/mutations/twoFaRegister.gql';
import { IUser } from '~/store/profile/types';
import TwoFaValidateQuery from '~/queries/twoFaValidate.gql';
import { isInvalidTwoFaError } from '~/utils/errorCodes';
import { consumeAccessToken, requestAccessToken } from '~/utils/pkceTokens';

@Component({
  components: { TwoFactorBox },
})
export default class TwoFactorAuthSetup extends Mixins(CopyToClipboard) {
  @State(profile => profile.user, { namespace: 'profile' })
  private user!: IUser;
  @State(profile => profile.user.twoFaEnabled, { namespace: 'profile' })
  private twoFaEnabled!: boolean;
  @Prop(String)
  readonly qrCode!: string;
  @Prop(String)
  readonly secret!: string;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;
  twoFaQrCode = '';
  twoFaSecret = '';
  isFetching: boolean = false;
  step: number = 1;
  btnDisabled: boolean = true;
  pin: string = '';
  logo = require(`@/assets/logos/gala-logo_horizontal_white.png`);
  auth0AccessToken: string = '';

  async registerForTwoFa() {
    return requestAccessToken('/account?component=TwoFa&action=register', [
      'enroll',
      'remove:authenticators',
      'read:authenticators',
    ]);
  }

  handleDisableBtn(disabled: boolean) {
    this.btnDisabled = disabled;
  }

  async continueRegister() {
    if (this.twoFaEnabled) {
      return;
    }

    const action = this.$route.query.action;

    if (action !== 'register') {
      return;
    }

    const accessToken = consumeAccessToken();

    if (!accessToken) {
      return;
    }

    this.auth0AccessToken = accessToken;
    this.step = 2;

    try {
      const registerResponse = await this.$apollo.mutate({
        mutation: twoFaRegister,
        variables: {
          auth0AccessToken: this.auth0AccessToken,
        },
      });

      const { twoFaSecret, twoFaQrCode } = registerResponse.data.twoFaRegister;
      this.twoFaSecret = twoFaSecret;
      this.twoFaQrCode = twoFaQrCode;

      // UA tracking
      this.$ua.trackTwoFASetupCompleteEvent();
    } catch (err) {
      this.$sentry.captureException(err);
      this.toggleErrorSnackbar(true);
      this.updateSnackbarErrorText(
        this.$t('common.notifications.somethingWentWrong'),
      );
    }
  }

  created() {
    this.continueRegister();
  }

  async validateTwoFa() {
    this.isFetching = true;
    try {
      const { data } = await this.$apollo.query({
        query: TwoFaValidateQuery,
        variables: {
          totpToken: this.pin,
          auth0AccessToken: this.auth0AccessToken,
        },
      });

      if (data?.twoFaValidate?.success) {
        // UA tracking
        this.$ua.trackTwoFAVerificationCompleteEvent();

        this.$emit('twofa-validated');
      } else {
        throw new Error('Unknown error');
      }
    } catch (error) {
      this.isFetching = false;
      console.warn(error);
      if (isInvalidTwoFaError(error)) {
        // UA tracking
        this.$ua.trackTwoFAVerificationInvalidCodeEvent();

        this.updateSnackbarErrorText(
          this.$t(
            'components.authentication.twoFactorAuthSetup.invalidPassword',
          ),
        );
      } else {
        // UA tracking
        this.$ua.trackTwoFAVerificationErrorEvent(error);

        this.$sentry.captureException(error);
        this.updateSnackbarErrorText(
          this.$t('common.notifications.somethingWentWrong'),
        );
        this.$sentry.captureException(error);
        this.updateSnackbarErrorText('Something went wrong');
      }
      this.toggleErrorSnackbar();
    }
  }
}
